import { render, staticRenderFns } from "./MarketPercentChart.vue?vue&type=template&id=23884a18"
import script from "./MarketPercentChart.vue?vue&type=script&lang=js"
export * from "./MarketPercentChart.vue?vue&type=script&lang=js"
import style0 from "./MarketPercentChart.vue?vue&type=style&index=0&id=23884a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports